import moment from 'moment';

// * Display MD as MM/DD/YYYY
const formatMD = ({ date = '', divider = '/', format = '' }) => {
  const specificFormat = format !== '' ? format : `MM${divider}DD${divider}YYYY`;
  return date ? moment(date).format(specificFormat) : null;
};

export default formatMD;
